export enum OperatorRoleType {
  ADMIN = 'ADMIN',
  SECURITY_ADMIN = 'SECURITY_ADMIN',
  DEVICE = 'DEVICE',
  ROUTER = 'ROUTER',
  MONITOR = 'MONITOR'
}
